var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcActivationLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2854",
    "data-name": "Rectangle 2854",
    width: 300,
    height: 300,
    transform: "translate(623 134)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2853",
    "data-name": "Rectangle 2853",
    width: 300,
    height: 300,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.048,
    y1: 0.503,
    x2: 1.03,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35a3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f3f98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.053,
    y1: 0.494,
    x2: 0.937,
    y2: 0.494,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.889,
    y1: 0.719,
    x2: 0.112,
    y2: 0.719,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_activation_link_expired",
    transform: "translate(-623 -134)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_linked_expired",
    transform: "translate(310.75 -601.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(312.251 735.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9148",
    "data-name": "Path 9148",
    d: "M573.269,937.679c-24.937,52.075-91.349,81.242-148.941,73.37-9.369-1.282-35.066-5.1-57.813-23.091-43.794-34.636-53.153-103.232-17.828-151.563,25.707-35.181,71.8-55.123,115.6-54.124,9.429.212,45.584,1.544,77.35,24.776a111.307,111.307,0,0,1,24.237,24.393c21.777,30.216,23.657,72.31,7.409,106.24Z",
    transform: "translate(-312.023 -736.884)",
    fill: "#cae4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9149",
    "data-name": "Path 9149",
    d: "M351.5,949.362s-.484-.959-1.272-2.684l1.776-.807c.767,1.675,1.231,2.594,1.241,2.6l-1.736.888Z",
    transform: "translate(-311.809 -734.686)",
    fill: "#cae4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9150",
    "data-name": "Path 9150",
    d: "M567.121,951.348l-1.27-1.474c1.44-1.261,2.881-2.6,4.281-3.966l1.35,1.4c-1.421,1.393-2.891,2.755-4.351,4.037Zm8.493-8.306-1.42-1.332c1.31-1.423,2.611-2.907,3.841-4.39l1.48,1.252c-1.26,1.514-2.571,3.017-3.911,4.471ZM347.9,942.981c-.72-1.786-1.44-3.653-2.131-5.541l1.82-.676c.69,1.867,1.4,3.714,2.111,5.48l-1.791.737Zm235.3-9.073-1.55-1.171c1.16-1.554,2.3-3.169,3.371-4.774l1.61,1.09c-1.09,1.635-2.241,3.27-3.431,4.854ZM343.813,931.84c-.62-1.867-1.22-3.775-1.791-5.662l1.851-.565c.56,1.867,1.15,3.754,1.771,5.6l-1.841.626ZM589.8,924.008l-1.66-1c.99-1.675,1.941-3.4,2.821-5.117l1.721.9c-.9,1.746-1.87,3.5-2.881,5.208Zm-249.385-3.542c-.51-1.907-1-3.845-1.451-5.763l1.881-.454c.45,1.9.93,3.815,1.43,5.7l-1.871.5Zm254.847-7.034-1.771-.8c.79-1.776,1.53-3.6,2.211-5.409l1.811.686C596.82,909.758,596.06,911.615,595.259,913.432ZM337.7,908.91c-.4-1.948-.76-3.916-1.09-5.843l1.911-.333c.32,1.907.68,3.845,1.08,5.783ZM599.43,902.27l-1.85-.575c.57-1.857,1.08-3.754,1.54-5.641l1.881.454c-.46,1.928-.99,3.855-1.57,5.753Zm-263.72-5.076c-.27-1.978-.5-3.956-.7-5.9l1.931-.2c.19,1.917.43,3.885.69,5.833l-1.921.262Zm266.491-6.52-1.911-.343c.33-1.907.61-3.855.83-5.783l1.921.222c-.22,1.978-.5,3.966-.84,5.9ZM334.51,885.365c-.13-1.988-.22-3.986-.27-5.944l1.931-.05c.05,1.928.14,3.906.27,5.864Zm269.012-6.55-1.931-.1c.08-1.615.12-3.26.12-4.885v-.959l1.941-.02v.979c0,1.655-.04,3.33-.12,4.986Zm-267.4-5.319-1.941-.02c.02-1.978.09-3.986.19-5.944l1.931.1c-.1,1.938-.16,3.916-.19,5.864Zm265.351-6.469c-.13-1.928-.32-3.885-.56-5.823l1.921-.242c.25,1.978.44,3.966.57,5.934Zm-264.74-5.248-1.931-.192c.19-1.978.42-3.966.69-5.914l1.921.273c-.27,1.917-.5,3.875-.68,5.823Zm263.3-6.368c-.34-1.887-.73-3.815-1.18-5.732l1.88-.444c.45,1.948.86,3.916,1.2,5.833l-1.911.343Zm-261.669-5.238-1.9-.363c.36-1.948.78-3.916,1.23-5.823l1.881.454C339.132,846.329,338.721,848.257,338.361,850.174Zm259.029-6.166c-.24-.858-.5-1.726-.76-2.594-.31-1.009-.63-2.018-.97-3.008l1.831-.626c.34,1.009.67,2.039.98,3.058.27.878.53,1.756.77,2.624l-1.86.535ZM341.062,838.78l-1.861-.545c.55-1.907,1.15-3.815,1.791-5.672l1.831.636c-.63,1.827-1.22,3.714-1.76,5.581Zm252.6-5.864c-.71-1.807-1.48-3.623-2.281-5.379l1.76-.817c.82,1.8,1.6,3.633,2.321,5.47Zm-248.785-5.207-1.791-.737c.74-1.827,1.53-3.674,2.361-5.46l1.751.828c-.82,1.766-1.6,3.573-2.321,5.369Zm243.944-5.43c-.9-1.716-1.851-3.441-2.831-5.107l1.66-1c1,1.7,1.971,3.451,2.891,5.2l-1.711.908ZM349.795,817.1l-1.71-.918c.92-1.746,1.9-3.492,2.911-5.187l1.661,1.009c-.99,1.665-1.961,3.381-2.861,5.1Zm233.091-4.875c-1.07-1.615-2.2-3.219-3.361-4.774l1.55-1.171c1.18,1.585,2.331,3.22,3.421,4.865l-1.611,1.09Zm-227.109-5.157-1.6-1.09c1.09-1.635,2.241-3.26,3.421-4.854l1.55,1.171C357.987,803.861,356.857,805.466,355.777,807.071Zm220.147-4.208c-1.23-1.483-2.521-2.957-3.831-4.39l1.42-1.332c1.33,1.453,2.641,2.957,3.891,4.471l-1.49,1.251Zm-213.175-5.157-1.481-1.251c1.25-1.5,2.581-3.007,3.941-4.451l1.41,1.342c-1.33,1.423-2.631,2.886-3.861,4.36Zm205.3-3.421c-1.38-1.352-2.811-2.695-4.251-3.986l1.28-1.464c1.47,1.312,2.921,2.675,4.321,4.047l-1.35,1.4Zm-197.33-5.066-1.33-1.423c1.42-1.342,2.9-2.674,4.421-3.956l1.24,1.494C373.562,786.594,372.112,787.9,370.721,789.218Zm188.627-2.685c-1.5-1.211-3.051-2.412-4.621-3.552l1.14-1.584c1.591,1.171,3.171,2.382,4.692,3.613ZM379.6,781.689l-1.16-1.564c1.56-1.181,3.181-2.341,4.812-3.452l1.08,1.625C382.725,779.388,381.134,780.528,379.6,781.689Zm170.342-2.049c-1.61-1.07-3.271-2.119-4.931-3.119l.99-1.675c1.691,1.019,3.371,2.079,5,3.169l-1.06,1.635Zm-160.719-4.481-1-1.675c1.661-1.009,3.391-2,5.122-2.947l.92,1.716c-1.711.928-3.411,1.907-5.042,2.9Zm150.726-1.534c-1.69-.918-3.431-1.817-5.182-2.684l.85-1.756c1.771.868,3.541,1.786,5.252,2.715l-.92,1.716ZM399.44,769.6l-.84-1.756c1.76-.848,3.571-1.675,5.372-2.452l.76,1.8c-1.781.767-3.561,1.574-5.292,2.412Zm130.039-1.12c-1.761-.777-3.581-1.534-5.382-2.24l.7-1.817c1.831.717,3.661,1.484,5.452,2.271l-.77,1.786ZM410.123,765l-.68-1.827c1.821-.686,3.681-1.352,5.562-1.978l.61,1.857c-1.851.616-3.691,1.272-5.482,1.948Zm108.5-.8c-1.821-.636-3.691-1.251-5.542-1.817l.56-1.867c1.881.575,3.761,1.2,5.612,1.847l-.63,1.847Zm-97.46-2.876-.53-1.877c1.861-.535,3.781-1.05,5.692-1.524l.46,1.9C424.9,760.284,423.007,760.788,421.167,761.323Zm86.316-.545c-1.871-.495-3.771-.969-5.662-1.4l.43-1.907c1.911.434,3.841.908,5.732,1.413l-.5,1.887Zm-75.023-2.24-.39-1.917c1.9-.394,3.851-.757,5.792-1.08l.32,1.928C436.261,757.791,434.341,758.144,432.46,758.538Zm63.649-.353c-1.891-.363-3.831-.7-5.742-.989l.29-1.928c1.941.3,3.891.636,5.812,1l-.36,1.918Zm-52.176-1.564-.25-1.938c1.941-.252,3.9-.474,5.852-.656l.18,1.948C447.795,756.156,445.844,756.368,443.933,756.62Zm40.662-.212c-1.911-.222-3.861-.424-5.792-.585l.16-1.948c1.951.161,3.931.363,5.862.585l-.22,1.938Zm-29.069-.878-.11-1.948c1.941-.111,3.921-.192,5.882-.232l.04,1.948c-1.941.04-3.9.121-5.822.232Zm17.455-.081c-1.93-.091-3.881-.151-5.822-.172l.02-1.958c1.961.02,3.941.081,5.892.182Z",
    transform: "translate(-311.957 -734.751)",
    fill: "#cae4fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9427",
    "data-name": "Path 9427",
    d: "M247.117,950.317l11.384-3.574a5.274,5.274,0,1,0-3.164-10.062L243.9,940.275l-2.713-8.49,11.474-3.6a14.189,14.189,0,1,1,8.51,27.073l-11.344,3.564-2.713-8.49Z",
    transform: "translate(-312.245 -734.688)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9428",
    "data-name": "Path 9428",
    d: "M261.5,944.27,271.021,943a12.51,12.51,0,0,0-.821-6.248C268.859,933.317,261.5,944.27,261.5,944.27Z",
    transform: "translate(-312.221 -734.678)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9429",
    "data-name": "Path 9429",
    d: "M281.064,932.782a14.2,14.2,0,0,1,1.281-20.024l13.126-11.534A14.189,14.189,0,1,1,314.2,922.54l-13.116,11.534a14.193,14.193,0,0,1-20.024-1.282Zm7.169-13.336a5.278,5.278,0,0,0,6.968,7.929l13.126-11.544a5.274,5.274,0,1,0-6.968-7.92l-13.116,11.534Z",
    transform: "translate(-312.202 -734.724)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9430",
    "data-name": "Path 9430",
    d: "M291.594,928.65l-7.649,6.608s-1.452-.711-3.865-3.745c-2.143-2.693,11.514-2.854,11.514-2.854Z",
    transform: "translate(-312.199 -734.687)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9431",
    "data-name": "Path 9431",
    d: "M308.9,915.187l9.582.421s.511-1.041.41-5.316-10,4.9-10,4.9Z",
    transform: "translate(-312.164 -734.711)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9432",
    "data-name": "Path 9432",
    d: "M302.062,899.891c-2.553.591-2.042-.46-.07-.881S304.615,899.311,302.062,899.891Z",
    transform: "translate(-312.174 -734.723)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9433",
    "data-name": "Path 9433",
    d: "M618.9,812.313l10.543-2.783,2.713,8.5-10.983,2.894a5.276,5.276,0,0,0,2.693,10.2l11.514-3.034,2.723,8.5-11.954,3.154a14.191,14.191,0,0,1-7.239-27.443Z",
    transform: "translate(-311.804 -734.83)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9434",
    "data-name": "Path 9434",
    d: "M617.854,813.641c-3.985,1.782-4.756,5.827,1.7,3.254S623.3,811.218,617.854,813.641Z",
    transform: "translate(-311.796 -734.827)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9435",
    "data-name": "Path 9435",
    d: "M427.175,833.222l-2.723-.09-1.3-1.031,1.412-.35Z",
    transform: "translate(-312.027 -734.804)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9436",
    "data-name": "Path 9436",
    d: "M463.05,883.884l3.024-1.412.31-1.942-2.032,1.131Z",
    transform: "translate(-311.979 -734.745)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9437",
    "data-name": "Path 9437",
    d: "M440.63,927.94l1.522.631.441,1.212-.7.07Z",
    transform: "translate(-312.006 -734.688)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9438",
    "data-name": "Path 9438",
    d: "M425.94,903.754l.821.751,3.614.971.971-5.3Z",
    transform: "translate(-312.023 -734.721)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9439",
    "data-name": "Path 9439",
    d: "M438.841,911.8l1.692-1.121-.621-5.5-.631-.951-1.412,4.575Z",
    transform: "translate(-312.009 -734.717)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9440",
    "data-name": "Path 9440",
    d: "M451.22,893.251l2.163-.791,3.244,1.482.811,1.221-2.653.39Z",
    transform: "translate(-311.993 -734.731)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9441",
    "data-name": "Path 9441",
    d: "M411.78,845.24l1.091-.01,2.163,2.293-2.363-.931Z",
    transform: "translate(-312.04 -734.787)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9442",
    "data-name": "Path 9442",
    d: "M446.11,853.385l1.692-.47.821-3.074-.721-.791-1.051,1.262Z",
    transform: "translate(-311.999 -734.783)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9443",
    "data-name": "Path 9443",
    d: "M464.17,845.6l.951-.621-.25-.951L464,844.6Z",
    transform: "translate(-311.978 -734.789)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9444",
    "data-name": "Path 9444",
    d: "M416.653,868.68l.24,1.422-2.153,3.494-.911-.02.891-3.234Z",
    transform: "translate(-312.038 -734.759)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9445",
    "data-name": "Path 9445",
    d: "M438.82,837.351l1.862-.611,2.143,1.962-2.2-.24Z",
    transform: "translate(-312.008 -734.798)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9446",
    "data-name": "Path 9446",
    d: "M432.955,864.79l.651,1.642-2.964,3.644-1.582-.34.961-2.163Z",
    transform: "translate(-312.02 -734.764)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9447",
    "data-name": "Path 9447",
    d: "M444.13,859.781l1.231,1.462,5.046-1.041-3.644-.981Z",
    transform: "translate(-312.001 -734.771)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9448",
    "data-name": "Path 9448",
    d: "M447.681,876.68s1.221-.34,2.823,1.071l.881-.03A6.948,6.948,0,0,1,453.2,883.7s-4.305.771-5.787-2.183a4.258,4.258,0,0,1,.27-4.836Z",
    transform: "translate(-311.998 -734.75)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9449",
    "data-name": "Path 9449",
    d: "M402.251,881.25c1.392-.781,3.3-.23,4.806,1.041l-.16.391s2.6,2.793,1.532,5.006c0,0-3.594,1.432-5.607-.931s-.571-5.517-.571-5.517Z",
    transform: "translate(-312.052 -734.745)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9450",
    "data-name": "Path 9450",
    d: "M404.762,867.04s2.413.39,3.745-3.855a4.215,4.215,0,0,0-1.031-4.636,7.157,7.157,0,0,0-4.305,4.2A3.319,3.319,0,0,0,404.762,867.04Z",
    transform: "translate(-312.051 -734.771)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9451",
    "data-name": "Path 9451",
    d: "M462.411,893.518c-.861-.431-1.2-1.792-.13-3.244,1.772-2.4,6.077-4.5,7.229-2.623s-1.382,5.487-1.382,5.487l-5.707.37Z",
    transform: "translate(-311.98 -734.737)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9452",
    "data-name": "Path 9452",
    d: "M475.642,869.27s-2,.641-1.6,5.417l.6.9a5.037,5.037,0,0,0,1.652,2.923c1.322.931,3.5-2.964,3.5-2.964l-4.155-6.277Z",
    transform: "translate(-311.966 -734.759)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9453",
    "data-name": "Path 9453",
    d: "M357.936,919.547l-17.341-2.123a14.187,14.187,0,0,1,3.454-28.164l17.341,2.123a14.187,14.187,0,0,1-3.454,28.164ZM342.968,898.1a5.275,5.275,0,1,0-1.282,10.473l17.341,2.123a5.275,5.275,0,1,0,1.282-10.473Z",
    transform: "translate(-312.141 -734.735)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9454",
    "data-name": "Path 9454",
    d: "M373.485,902.392l-.911-1.382-7.689,4.035c.03.34-.29.561-.33.921a5.149,5.149,0,0,1-3.384,4.526h.01c2.583-.591,1.932.621,3.815,0,1.622-.541,8.44-8.04,8.48-8.08h0Z",
    transform: "translate(-312.101 -734.72)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9455",
    "data-name": "Path 9455",
    d: "M339.592,907.821l-8.55,4.095a9.688,9.688,0,0,1-1.622-2.954C328.469,906.659,339.592,907.821,339.592,907.821Z",
    transform: "translate(-312.139 -734.713)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9456",
    "data-name": "Path 9456",
    d: "M402.28,881.278h0l-6.728,7.3a5.275,5.275,0,1,1-7.759-7.149l11.834-12.855a5.278,5.278,0,0,1,5.166-1.542h0c-1.322-5.887,2.7-8.49,2.713-8.5a14.218,14.218,0,0,0-14.437,3.995l-11.834,12.856A14.193,14.193,0,0,0,402.12,894.6l6.348-6.888c-5.467-.36-6.177-6.448-6.177-6.448Z",
    transform: "translate(-312.082 -734.772)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9457",
    "data-name": "Path 9457",
    d: "M392.283,890.2l-7.209,7.329a12.427,12.427,0,0,1-3.384-2.563c-1.632-1.752,10.593-4.766,10.593-4.766Z",
    transform: "translate(-312.077 -734.733)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9458",
    "data-name": "Path 9458",
    d: "M491.875,872.644l-16.219-3.374s3.614,5.206.651,9.241l13.756,2.863a5.272,5.272,0,0,1-2.153,10.322l-17.1-3.564a5.735,5.735,0,0,1-1.3-.461h0a9.76,9.76,0,0,1-7.089,5.857A14.1,14.1,0,0,0,469,896.863l17.1,3.564a14.19,14.19,0,0,0,5.787-27.783Z",
    transform: "translate(-311.979 -734.759)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9459",
    "data-name": "Path 9459",
    d: "M490.89,891.41l9.261,3.8a14.851,14.851,0,0,0,1.742-2.974C502.424,890.859,490.89,891.41,490.89,891.41Z",
    transform: "translate(-311.945 -734.732)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9460",
    "data-name": "Path 9460",
    d: "M548.372,896.944l-16.89,4.455a14.191,14.191,0,1,1-7.239-27.443l16.89-4.455a14.191,14.191,0,0,1,7.239,27.443Zm-21.856-14.367a5.27,5.27,0,1,0,2.683,10.192l16.9-4.455a5.271,5.271,0,1,0-2.693-10.192Z",
    transform: "translate(-311.918 -734.759)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9461",
    "data-name": "Path 9461",
    d: "M548.52,886.862l10.343-4.656a16.792,16.792,0,0,0-1.221-5.166c-1.1-2.583-9.121,9.832-9.121,9.832Z",
    transform: "translate(-311.876 -734.749)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9462",
    "data-name": "Path 9462",
    d: "M525.8,892.5l-10.493,1.772a16.815,16.815,0,0,1-1.282-3.494C513.74,889.289,525.8,892.5,525.8,892.5Z",
    transform: "translate(-311.917 -734.733)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9463",
    "data-name": "Path 9463",
    d: "M621.923,831.24l-6.318,7.149a11.143,11.143,0,0,1-4.455-3.835c-1.982-2.843,10.763-3.314,10.763-3.314Z",
    transform: "translate(-311.801 -734.804)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9464",
    "data-name": "Path 9464",
    d: "M599.634,855.928,588.04,868.994a14.191,14.191,0,0,1-21.225-18.843l11.594-13.066a14.191,14.191,0,0,1,21.226,18.843Zm-26.151.14a5.276,5.276,0,0,0,7.889,7.008l11.6-13.066a5.273,5.273,0,0,0-7.889-7l-11.594,13.066Z",
    transform: "translate(-311.858 -734.803)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9465",
    "data-name": "Path 9465",
    d: "M594.09,847.83l9.071-1.732a8.018,8.018,0,0,0-1.932-5.967C598.766,836.967,594.09,847.83,594.09,847.83Z",
    transform: "translate(-311.821 -734.794)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9466",
    "data-name": "Path 9466",
    d: "M578.393,864.72l-6.047,8.07a11.856,11.856,0,0,1-4.706-2.984c-1.011-1.131,10.753-5.1,10.753-5.1Z",
    transform: "translate(-311.853 -734.764)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9467",
    "data-name": "Path 9467",
    d: "M575.143,842.024c4.205-4.946,7.95-4.525,2.713,1.482C572.36,849.813,570.748,847.18,575.143,842.024Z",
    transform: "translate(-311.847 -734.795)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9468",
    "data-name": "Path 9468",
    d: "M342.81,907.071l-35.833,8.59a4.458,4.458,0,1,1-2.082-8.67l35.833-8.59a4.459,4.459,0,1,1,2.083,8.67Z",
    transform: "translate(-312.173 -734.724)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9469",
    "data-name": "Path 9469",
    d: "M292.557,928.18l-32.709,16.97a4.456,4.456,0,1,1-4.1-7.909l32.709-16.97a4.456,4.456,0,1,1,4.1,7.91Z",
    transform: "translate(-312.231 -734.698)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9470",
    "data-name": "Path 9470",
    d: "M275.589,928.535c11.083-6.278,15.869-5.517,1.472,2.1S267.319,933.211,275.589,928.535Z",
    transform: "translate(-312.213 -734.692)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9471",
    "data-name": "Path 9471",
    d: "M279.042,926.541c2.984-1.492,2.052-.31.3.611S276.2,927.963,279.042,926.541Z",
    transform: "translate(-312.202 -734.69)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9472",
    "data-name": "Path 9472",
    d: "M394,889.12l-30.917,20.044a4.459,4.459,0,1,1-4.856-7.479l30.917-20.044A4.458,4.458,0,0,1,394,889.12Z",
    transform: "translate(-312.107 -734.745)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9473",
    "data-name": "Path 9473",
    d: "M526.329,892.532l-36.834-1.1a4.457,4.457,0,1,1,.26-8.911l36.824,1.1a4.462,4.462,0,0,1-.26,8.921Z",
    transform: "translate(-311.952 -734.743)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9474",
    "data-name": "Path 9474",
    d: "M578.154,864.98,548.529,886.9a4.459,4.459,0,1,1-5.306-7.169l29.626-21.916a4.459,4.459,0,1,1,5.306,7.169Z",
    transform: "translate(-311.884 -734.773)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9475",
    "data-name": "Path 9475",
    d: "M623.976,830.05l-31.658,18.863a4.458,4.458,0,0,1-4.566-7.659l31.658-18.863a4.458,4.458,0,1,1,4.566,7.659Z",
    transform: "translate(-311.831 -734.816)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9476",
    "data-name": "Path 9476",
    d: "M461.83,892.955a1.531,1.531,0,0,0,.581.561c3.7-.36,6.388-4.475,6.388-4.475A12.635,12.635,0,0,1,461.83,892.955Z",
    transform: "translate(-311.98 -734.735)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9477",
    "data-name": "Path 9477",
    d: "M402.65,882.86a7.269,7.269,0,0,0,6,4.185l-.21.641a6.594,6.594,0,0,1-5.787-4.836Z",
    transform: "translate(-312.051 -734.742)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9478",
    "data-name": "Path 9478",
    d: "M433.1,877.5s-1.582-1.872-5.236-1.7-3.6,2.853-3.6,2.853,1.692,3.474,4.455,3.114,4.385-4.275,4.385-4.275Z",
    transform: "translate(-312.025 -734.751)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9479",
    "data-name": "Path 9479",
    d: "M424.275,878.661h0a5.109,5.109,0,0,1,.06,1.111,5.28,5.28,0,0,1-5.537,5l-5-.25s-3.815,4.816-.751,8.891l5.306.271a14.2,14.2,0,0,0,14.768-16.17c-4.045,3.995-8.841,1.161-8.841,1.161Z",
    transform: "translate(-312.04 -734.749)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9480",
    "data-name": "Path 9480",
    d: "M455.2,866.5s-.34,2.433,2.243,5.026,4.535.761,4.535.761,1.452-3.584-.671-5.4-6.117-.4-6.117-.4Z",
    transform: "translate(-311.988 -734.763)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9481",
    "data-name": "Path 9481",
    d: "M470.178,872.273l.751.921a9.564,9.564,0,0,0,3.054-9.381,14.226,14.226,0,0,0-16.85.781,13.976,13.976,0,0,0-1.932,1.912c5.677.33,6.778,5.787,6.778,5.787h0a5.824,5.824,0,0,1,.781-.791,5.285,5.285,0,0,1,7.419.761Z",
    transform: "translate(-311.988 -734.768)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9482",
    "data-name": "Path 9482",
    d: "M424.26,878.66a7.327,7.327,0,0,0,6.688.361A12.649,12.649,0,0,1,424.26,878.66Z",
    transform: "translate(-312.025 -734.747)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9483",
    "data-name": "Path 9483",
    d: "M421.39,859.6s1.932,4.666,9.151.931a3.8,3.8,0,0,0-3.314-3.674c-3.264-.471-5.837,2.743-5.837,2.743Z",
    transform: "translate(-312.029 -734.773)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9484",
    "data-name": "Path 9484",
    d: "M430.541,860.543h0L433.294,853h0s-3.074-4.415-8.37-3.084h0l-3.534,9.692A7.224,7.224,0,0,1,430.541,860.543Z",
    transform: "translate(-312.029 -734.782)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9485",
    "data-name": "Path 9485",
    d: "M454.551,918.75s5.106-.871,5.807-7.129c0,0-4.716-2.193-6.308.7s.5,6.438.5,6.438Z",
    transform: "translate(-311.99 -734.708)",
    fill: "#003b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9486",
    "data-name": "Path 9486",
    d: "M460.369,911.63h0l-10.042-8.18a7.786,7.786,0,0,0-5.767,6.588l2.183,1.992,7.819,6.738s.26-4.515,5.807-7.129Z",
    transform: "translate(-312.001 -734.717)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9487",
    "data-name": "Path 9487",
    d: "M450.162,885.541A14.419,14.419,0,0,0,453.2,883.7c-5.967-1.722-5.507-7.018-5.507-7.018h0a5.507,5.507,0,0,1-1.161.721,5.232,5.232,0,0,1-3.865.17h0a11.839,11.839,0,0,0-2.032,8.7,14.093,14.093,0,0,0,9.541-.731Z",
    transform: "translate(-312.006 -734.75)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9488",
    "data-name": "Path 9488",
    d: "M449.53,881.6a6.3,6.3,0,0,0,3.654,2.1l.09-.731A5.328,5.328,0,0,1,449.53,881.6Z",
    transform: "translate(-311.995 -734.744)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9489",
    "data-name": "Path 9489",
    d: "M446.11,853.385l-.25-3.614,2.042-.721Z",
    transform: "translate(-311.999 -734.783)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9490",
    "data-name": "Path 9490",
    d: "M444.13,859.783l6.278.42.5-3.094Z",
    transform: "translate(-312.001 -734.773)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9491",
    "data-name": "Path 9491",
    d: "M415.034,847.523l-3.254-2.283.12,2.133Z",
    transform: "translate(-312.04 -734.787)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9492",
    "data-name": "Path 9492",
    d: "M442.825,838.7l-4-1.352.24,1.842Z",
    transform: "translate(-312.008 -734.797)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9493",
    "data-name": "Path 9493",
    d: "M439.283,904.23l-.441,7.569-2.233-1.482Z",
    transform: "translate(-312.011 -734.717)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9494",
    "data-name": "Path 9494",
    d: "M451.22,893.25l6.217,1.912-2.443,3-3.755-3.574Z",
    transform: "translate(-311.993 -734.73)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9495",
    "data-name": "Path 9495",
    d: "M462.31,843.95l2.563.08-.7,1.572-1.4-.961Z",
    transform: "translate(-311.979 -734.789)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9496",
    "data-name": "Path 9496",
    d: "M431.347,900.18,429.4,904.3l-3.464-.551,3.484-3.164Z",
    transform: "translate(-312.023 -734.721)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9497",
    "data-name": "Path 9497",
    d: "M430.991,913.35l.1,2.3-1.261.25Z",
    transform: "translate(-312.019 -734.706)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9498",
    "data-name": "Path 9498",
    d: "M445.433,820.21l-2.073,1.031-.741-1.061Z",
    transform: "translate(-312.003 -734.818)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9499",
    "data-name": "Path 9499",
    d: "M467.84,907.47l3.795-.01-1.081,1.241Z",
    transform: "translate(-311.973 -734.713)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9500",
    "data-name": "Path 9500",
    d: "M426.37,867.2l4.365-3.654,2.223,1.242-3.895,4.946Z",
    transform: "translate(-312.023 -734.765)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M413.83,873.578l.681-6.668,2.143,1.772Z",
    transform: "translate(-312.038 -734.761)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9502",
    "data-name": "Path 9502",
    d: "M437.99,889.68l3.014,1.3-.771,1.342Z",
    transform: "translate(-312.009 -734.734)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9503",
    "data-name": "Path 9503",
    d: "M444.67,870.391l2.143.531,1-1.492Z",
    transform: "translate(-312.001 -734.758)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9504",
    "data-name": "Path 9504",
    d: "M458.56,831.583l1.251-2.663.441,1.552Z",
    transform: "translate(-311.984 -734.807)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9505",
    "data-name": "Path 9505",
    d: "M440.63,927.94l1.1,2.893.861-1.051Z",
    transform: "translate(-312.006 -734.688)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9506",
    "data-name": "Path 9506",
    d: "M427.175,833.222,423.15,832.1l1.141-.751Z",
    transform: "translate(-312.027 -734.804)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9507",
    "data-name": "Path 9507",
    d: "M433.482,845.255l-1.091-4.135-.921,1.091Z",
    transform: "translate(-312.017 -734.792)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9508",
    "data-name": "Path 9508",
    d: "M463.05,883.884l3.334-3.354-2.343-.02Z",
    transform: "translate(-311.979 -734.745)",
    fill: "#80afc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M457.437,895.163l-6.217-1.912.641-.24Z",
    transform: "translate(-311.993 -734.73)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M438.84,911.794l.18-3.083.32,2.753Z",
    transform: "translate(-312.008 -734.711)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M429.4,904.3l-3.464-.551,3.664.14Z",
    transform: "translate(-312.023 -734.717)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M432.955,864.79l-3.895,4.946.571.13Z",
    transform: "translate(-312.02 -734.764)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M446.11,853.385l1.792-4.335.3.32Z",
    transform: "translate(-311.999 -734.783)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    "data-name": "Path 9514",
    d: "M442.825,838.7l-4-1.352.521-.17Z",
    transform: "translate(-312.008 -734.797)",
    fill: "#4a738b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M413.823,846.672l-2.043-1.432.451-.01Z",
    transform: "translate(-312.04 -734.787)",
    fill: "#4a738b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9151",
    "data-name": "Path 9151",
    d: "M560,955.11l-1.08-1.625s.868-.575,2.321-1.675l1.181,1.554c-1.5,1.151-2.392,1.736-2.422,1.756Z",
    transform: "translate(-312.287 -734.679)",
    fill: "#cae4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9284",
    "data-name": "Path 9284",
    d: "M356.17,957.887a29.665,29.665,0,0,1,7.286-3.169l1.5-7.216,12.191-.212,1.756,7.155a29.683,29.683,0,0,1,7.4,2.906l6.156-4.037,8.77,8.467-3.815,6.3a29.835,29.835,0,0,1,3.169,7.286l7.216,1.5.212,12.191-7.155,1.756a29.681,29.681,0,0,1-2.907,7.4l4.037,6.156-8.467,8.77-6.3-3.815a29.83,29.83,0,0,1-7.286,3.169l-1.5,7.216-12.191.212-1.756-7.155a29.684,29.684,0,0,1-7.4-2.906l-6.156,4.037-8.77-8.467,3.815-6.3a29.661,29.661,0,0,1-3.169-7.286l-7.216-1.5-.212-12.191,7.155-1.756a29.685,29.685,0,0,1,2.906-7.4l-4.037-6.156,8.467-8.77,6.3,3.815Zm6.5,16.238a13.076,13.076,0,1,0,18.489-.323A13.073,13.073,0,0,0,362.669,974.125Z",
    transform: "translate(-327.691 -735.364)",
    fill: "#45a1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9285",
    "data-name": "Path 9285",
    d: "M425.929,945.206a14.158,14.158,0,0,1,3.431-1.494l.706-3.391,5.732-.1.828,3.371a13.666,13.666,0,0,1,3.482,1.372l2.9-1.9,4.128,3.986-1.8,2.957a14.151,14.151,0,0,1,1.494,3.431l3.391.706.1,5.732-3.371.828a14.051,14.051,0,0,1-1.372,3.482l1.9,2.9-3.986,4.128-2.967-1.8a14.155,14.155,0,0,1-3.431,1.494l-.706,3.391-5.732.1-.828-3.371a14.042,14.042,0,0,1-3.482-1.372l-2.9,1.9-4.128-3.986,1.8-2.967a14.157,14.157,0,0,1-1.494-3.431l-3.391-.706-.1-5.732,3.371-.828a14.054,14.054,0,0,1,1.372-3.482l-1.9-2.9,3.986-4.128,2.967,1.8h0Zm3.058,7.64a6.152,6.152,0,1,0,8.7-.151A6.153,6.153,0,0,0,428.987,952.845Z",
    transform: "translate(-327.746 -734.883)",
    fill: "#9fd4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9412",
    "data-name": "Path 9412",
    d: "M592.687,794.847c6.015,19.232-.918,41.772-16.743,54.416-10.546,8.426-23.979,12.354-35.655,19.172s-22.364,18.6-20.86,31.936c1.534,13.574,14.533,22.44,23.161,33.1a57.865,57.865,0,0,1-7.418,80.465L423.421,983.8s-9.446-42.352,23.555-63.782,46.686-18.242,50.834-37.014-7.276-28.318-12.847-37.274-37.573-34.995-1.978-80.475l109.7,29.577Z",
    transform: "translate(-313.547 -734.641)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9413",
    "data-name": "Path 9413",
    d: "M592.688,794.847s-.646-.19-1.918-.53-3.179-.87-5.662-1.539c-4.986-1.349-12.333-3.349-21.8-5.907-18.953-5.128-46.383-12.545-80.283-21.711l-.081-.02-.05.07a107.225,107.225,0,0,0-7.458,10.865,72.1,72.1,0,0,0-5.954,12.385,53.26,53.26,0,0,0-3.068,13.944,45.141,45.141,0,0,0,1.383,14.724,49.993,49.993,0,0,0,2.543,7.187,57.4,57.4,0,0,0,3.653,6.847c1.372,2.219,2.886,4.368,4.5,6.477s3.32,4.148,4.965,6.267c.828,1.06,1.534,2.179,2.281,3.319.757,1.119,1.554,2.219,2.362,3.319,1.615,2.189,3.25,4.388,4.733,6.707a33.281,33.281,0,0,1,5.591,15.514,32.455,32.455,0,0,1-.444,8.436c-.131.7-.232,1.409-.394,2.1s-.323,1.389-.545,2.069a24.236,24.236,0,0,1-1.554,4.008,19.492,19.492,0,0,1-5.44,6.677,44.1,44.1,0,0,1-7.509,4.648c-5.3,2.7-10.809,5.148-16.208,7.947q-8.114,4.153-16.016,9.066a79.152,79.152,0,0,0-7.69,5.278,50,50,0,0,0-6.812,6.477,52.709,52.709,0,0,0-9.638,16.253,65.983,65.983,0,0,0-3.986,18.742,77.671,77.671,0,0,0-.091,9.7,68.478,68.478,0,0,0,1.14,9.7l.02.1.1.03c.908.24,1.887.51,2.876.78,38.148,10.286,74.954,20.2,108.874,29.348l.091.02.071-.06a59.187,59.187,0,0,0,16.541-23.6,56.554,56.554,0,0,0,3.381-27.418,58.95,58.95,0,0,0-9.033-24.879,68.884,68.884,0,0,0-8.084-10.006c-2.9-3.089-5.874-6.017-8.6-9.086A48.691,48.691,0,0,1,522.4,909.3a25.4,25.4,0,0,1-2.977-11.185,24.668,24.668,0,0,1,2.523-10.905,36.3,36.3,0,0,1,6.176-8.986,50.828,50.828,0,0,1,7.953-6.947,71.193,71.193,0,0,1,8.74-5.2c5.914-3.039,11.8-5.508,17.217-8.207,2.715-1.349,5.319-2.739,7.771-4.238a56.682,56.682,0,0,0,6.812-4.858,49.264,49.264,0,0,0,10-11.405,50.853,50.853,0,0,0,5.591-11.845c.353-.94.585-1.9.838-2.829s.515-1.829.666-2.729c.172-.9.343-1.769.5-2.619.131-.86.212-1.7.313-2.509a47.349,47.349,0,0,0-.6-14.964,17.425,17.425,0,0,0-.484-2.2c-.172-.62-.313-1.15-.434-1.569-.232-.84-.353-1.26-.353-1.26.02.09.121.46.333,1.28.111.42.252.95.414,1.569a19.743,19.743,0,0,1,.464,2.2,47.624,47.624,0,0,1,.535,14.944c-.1.81-.192,1.649-.323,2.509-.161.85-.333,1.719-.515,2.619-.151.9-.424,1.8-.666,2.719s-.484,1.879-.838,2.819a50.678,50.678,0,0,1-5.6,11.8,49.158,49.158,0,0,1-9.981,11.345,58.249,58.249,0,0,1-6.792,4.828c-2.452,1.489-5.046,2.879-7.761,4.218-5.419,2.689-11.3,5.148-17.227,8.187a71.149,71.149,0,0,0-8.77,5.208,50.284,50.284,0,0,0-7.993,6.977,36.446,36.446,0,0,0-6.227,9.046,24.867,24.867,0,0,0-2.553,11.025,25.512,25.512,0,0,0,3,11.305,48.655,48.655,0,0,0,7.115,9.846c2.735,3.079,5.712,6.017,8.6,9.1a69.383,69.383,0,0,1,8.043,9.966,59.012,59.012,0,0,1,8.972,24.76,56.271,56.271,0,0,1-3.371,27.259,58.879,58.879,0,0,1-16.45,23.47l.151-.04c-33.92-9.146-70.726-19.072-108.874-29.357l-2.876-.78.131.13a67.435,67.435,0,0,1-1.14-9.646,77.019,77.019,0,0,1,.091-9.656,66.034,66.034,0,0,1,3.956-18.652,52.233,52.233,0,0,1,9.567-16.153,49.277,49.277,0,0,1,6.762-6.427,77.905,77.905,0,0,1,7.66-5.258q7.872-4.9,15.986-9.056c5.389-2.8,10.889-5.248,16.208-7.957a44.661,44.661,0,0,0,7.559-4.688,19.682,19.682,0,0,0,5.52-6.787,24.844,24.844,0,0,0,1.574-4.058c.222-.69.373-1.389.555-2.089.161-.7.262-1.409.394-2.119a33.138,33.138,0,0,0,.444-8.526,33.615,33.615,0,0,0-5.652-15.653c-1.484-2.329-3.129-4.538-4.743-6.727-.807-1.09-1.6-2.189-2.362-3.309-.737-1.12-1.463-2.269-2.3-3.329-1.655-2.119-3.371-4.158-4.975-6.257s-3.119-4.238-4.481-6.447a58.207,58.207,0,0,1-3.633-6.807,49.315,49.315,0,0,1-2.533-7.137,45.15,45.15,0,0,1-1.383-14.634,52.334,52.334,0,0,1,3.048-13.864,71.955,71.955,0,0,1,5.924-12.345,106.2,106.2,0,0,1,7.428-10.845l-.131.04c33.9,9.116,61.32,16.483,80.273,21.581,9.477,2.539,16.844,4.518,21.829,5.858,2.493.67,4.4,1.17,5.682,1.519s1.948.51,1.948.51Z",
    transform: "translate(-313.548 -734.642)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9414",
    "data-name": "Path 9414",
    d: "M478.725,796.561c-17.2-1.776.817,34.444,12.383,49.936,6.691,8.972,13.857,18.681,15.168,29.8,1.484,12.615-5.389,24.463-6.277,36.5a1.648,1.648,0,0,0,3.24.525,128.858,128.858,0,0,1,7.428-22.031c4.612-10,11.465-19.276,20.9-24.958,7.7-4.642,16.7-6.661,24.685-10.788,11.666-6.015,24.261-14.442,28.642-26.815,0,0-14-19.326-24.443-20.2-12.212-1.039-28.541,13.8-46.01,6.832-12.191-4.864-15.774-16.753-35.726-18.812Z",
    transform: "translate(-313.091 -735.162)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9415",
    "data-name": "Path 9415",
    d: "M435.165,950.847c1.534-4.006,3.906-8.366,8.084-9.3a10.579,10.579,0,0,1,7.438,1.584c2.251,1.3,4.229,3.017,6.439,4.39a24.082,24.082,0,0,0,14.664,3.492c4.915-.424,9.557-2.352,14.331-3.552s10.112-1.615,14.411.787c7.418,4.148,8.952,14.855,16.2,19.316,3.219,1.978,7.135,2.422,10.91,2.584s7.63.1,11.233,1.231a12.409,12.409,0,0,1,6.994,5.177v-.03a.275.275,0,0,0,.03.081,8.543,8.543,0,0,1,.616,1.3c1.554,3.916.757,8.4-1.08,12.171-2.049,4.219-5.248,7.771-8.548,11.1-3.9,3.926-8.134,7.731-13.322,9.648-6.4,2.362-12.423-2.109-19.125-3.381-15.633-2.957-32.315-6.61-47.292-11.969-7.912-2.826-15.724-4.017-20.79-10.718a27.018,27.018,0,0,1-4.975-16.682,50.6,50.6,0,0,1,3.795-17.227Z",
    transform: "translate(-312.611 -735.418)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5365",
    "data-name": "Group 5365",
    transform: "translate(130.959 213.044)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9416",
    "data-name": "Path 9416",
    d: "M466.08,950.762a4.364,4.364,0,0,1-.807,4.542c-1.2,1.12-2.654,2.028-3.431,3.472-1.221,2.261-.414,5.016.061,7.549a23.127,23.127,0,0,1-1.352,13.523,18.253,18.253,0,0,1-9.5,9.547c-1.877.777-4.148,1.161-5.863.061a5.431,5.431,0,0,1-2.119-5.046,17.976,17.976,0,0,1,1.675-5.47,88.882,88.882,0,0,0,6.328-25.8c.131-1.484.333-3.159,1.534-4.037a5,5,0,0,1,2.715-.7c3.724-.2,7.054,2.059,10.768,2.352",
    transform: "translate(-443.049 -948.397)",
    fill: "#cae4fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9417",
    "data-name": "Path 9417",
    d: "M542.094,1021.671s1.706-5.046-4.208-9.719L420.342,979.96s-6.974,1.433-9.032,6l130.774,35.716Z",
    transform: "translate(-312.648 -735.063)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9418",
    "data-name": "Path 9418",
    d: "M481.274,765.69c.05.05.111.091.161.141L592.156,795.2s.464-.141,1.171-.444a4.346,4.346,0,0,0-.575-8.2L485.24,758.221A4.341,4.341,0,0,0,481.274,765.69Z",
    transform: "translate(-313.016 -734.707)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5366",
    "data-name": "Group 5366",
    transform: "translate(174.923 77.156)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9419",
    "data-name": "Path 9419",
    d: "M487.421,812.171c-.343.363.242,1.514,1.443,3.351s3,4.4,5.308,7.579a92.838,92.838,0,0,0,9,10.889,46.48,46.48,0,0,0,6.681,5.581,37.134,37.134,0,0,0,4.057,2.412,29.814,29.814,0,0,0,4.572,1.907,26.4,26.4,0,0,0,9.88,1.292,35.792,35.792,0,0,0,8.72-1.827c2.6-.858,4.895-1.786,7.054-2.674s4.148-1.786,5.944-2.644c7.175-3.451,11.232-6.318,10.839-7.2-.4-.908-5.157.323-12.635,2.523-1.867.545-3.916,1.151-6.106,1.786s-4.552,1.342-6.933,1.948A34.328,34.328,0,0,1,528,838.259a21.334,21.334,0,0,1-7.337-1.1,39.018,39.018,0,0,1-13.039-7.922c-3.684-3.24-6.853-6.631-9.668-9.4a58.144,58.144,0,0,0-7.125-6.237c-1.867-1.3-3.088-1.786-3.421-1.433Z",
    transform: "translate(-487.324 -812.059)",
    fill: "#cae4fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9420",
    "data-name": "Path 9420",
    d: "M499.107,926.153a1.937,1.937,0,1,0,.081.06",
    transform: "translate(-311.957 -734.71)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9421",
    "data-name": "Path 9421",
    d: "M561.4,852.195s.182-.091.495-.283q.515-.333,1.393-.878c.6-.394,1.352-.838,2.17-1.443s1.766-1.282,2.8-2.028c.989-.817,2.089-1.675,3.229-2.664.555-.515,1.13-1.039,1.716-1.584.293-.272.606-.545.888-.838s.575-.605.868-.908a45.454,45.454,0,0,0,6.742-8.7,42.615,42.615,0,0,0,4.4-10.082c.222-.818.394-1.625.585-2.4.091-.394.2-.777.262-1.161s.121-.767.182-1.13c.111-.747.242-1.463.333-2.16.06-.7.121-1.362.172-2.008.141-1.272.111-2.432.141-3.452,0-.5.03-.979,0-1.413s-.04-.828-.061-1.191c-.04-.686-.071-1.241-.091-1.645a2.98,2.98,0,0,0-.06-.575,3.141,3.141,0,0,0-.01.575c0,.4.02.959.03,1.645,0,.363.02.757.03,1.191s-.03.908-.04,1.413c-.05,1.009-.03,2.17-.192,3.431-.061.636-.131,1.3-.192,1.988-.091.686-.232,1.4-.353,2.14-.061.373-.121.747-.192,1.13s-.182.757-.272,1.151c-.192.777-.374,1.574-.6,2.382a43.693,43.693,0,0,1-4.39,9.991,46.632,46.632,0,0,1-6.671,8.649c-.293.3-.575.606-.858.908s-.6.555-.878.838c-.585.545-1.151,1.07-1.7,1.584-1.13.989-2.22,1.857-3.189,2.684-1.019.767-1.938,1.453-2.755,2.069s-1.554,1.07-2.129,1.483c-.565.394-1.019.706-1.352.939a4.21,4.21,0,0,0-.454.343Z",
    transform: "translate(-312.264 -734.938)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9422",
    "data-name": "Path 9422",
    d: "M541.564,950.754s-.02-.091-.061-.252c-.05-.182-.131-.414-.222-.727s-.232-.717-.373-1.171c-.071-.232-.151-.484-.242-.747s-.232-.535-.353-.818c-.262-.575-.545-1.221-.858-1.917-.353-.676-.787-1.4-1.221-2.19a46.433,46.433,0,0,0-3.472-5.016c-2.765-3.583-6.54-7.428-10.576-11.818a78.439,78.439,0,0,1-5.954-7.186,35.7,35.7,0,0,1-4.7-8.78,34.165,34.165,0,0,1-.555-19.044,43,43,0,0,1,6.58-14.26,58.332,58.332,0,0,1,6.883-8.134c.9-.888,1.615-1.554,2.1-2,.232-.212.414-.383.555-.515l.182-.182s-.071.05-.2.161-.333.283-.575.484c-.5.434-1.241,1.08-2.15,1.958a55.164,55.164,0,0,0-6.984,8.084,42.883,42.883,0,0,0-6.691,14.331,37.214,37.214,0,0,0-1.11,9.315,32.342,32.342,0,0,0,1.645,9.931,35.925,35.925,0,0,0,4.763,8.871,74.88,74.88,0,0,0,5.995,7.206c4.057,4.38,7.842,8.195,10.617,11.747a47.268,47.268,0,0,1,3.5,4.965c.444.777.878,1.484,1.241,2.16.323.7.616,1.332.878,1.9.131.283.262.555.373.807.091.262.172.5.252.737.161.454.293.838.4,1.161.111.3.192.535.252.706a1.142,1.142,0,0,0,.1.242Z",
    transform: "translate(-312.096 -735.171)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9423",
    "data-name": "Path 9423",
    d: "M544.262,963.1a1.463,1.463,0,0,0,.061.343c.06.262.141.575.242.959.111.414.242.928.353,1.524s.283,1.272.373,2.039c.05.383.111.777.172,1.191s.081.848.121,1.3c.1.9.1,1.857.131,2.876a39.146,39.146,0,0,1-.555,6.56,40.627,40.627,0,0,1-1.716,6.358c-.373.939-.706,1.847-1.11,2.654-.192.4-.363.807-.555,1.181s-.383.727-.565,1.06c-.343.686-.737,1.262-1.04,1.786s-.605.959-.848,1.312c-.222.333-.4.6-.555.817a1.271,1.271,0,0,0-.172.3,2.161,2.161,0,0,0,.232-.262q.242-.318.605-.787c.262-.343.585-.767.908-1.282s.737-1.09,1.1-1.776c.192-.343.383-.7.6-1.06s.383-.777.575-1.181c.414-.807.767-1.716,1.15-2.664a35.344,35.344,0,0,0,2.3-13.029c-.04-1.019-.05-2-.172-2.9-.05-.454-.081-.888-.141-1.312s-.131-.818-.192-1.2c-.1-.767-.293-1.443-.424-2.039s-.283-1.11-.414-1.514c-.121-.384-.222-.686-.3-.949a1.341,1.341,0,0,0-.131-.323Z",
    transform: "translate(-311.934 -735.218)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9424",
    "data-name": "Path 9424",
    d: "M459.63,956.85a.791.791,0,0,0,.111.131c.091.1.2.222.343.363.323.343.767.8,1.332,1.393l.969,1c.363.353.787.707,1.231,1.11.9.777,1.867,1.726,3.078,2.6.6.454,1.211.928,1.857,1.433s1.383.928,2.109,1.433c1.433,1.019,3.088,1.917,4.8,2.9a63.443,63.443,0,0,0,24.484,7.357c1.978.121,3.845.293,5.611.232.878-.01,1.726.02,2.543-.03s1.595-.111,2.341-.172a39.466,39.466,0,0,0,4.007-.474c.585-.091,1.14-.151,1.635-.252s.949-.212,1.362-.3q1.2-.272,1.877-.424.288-.076.484-.121c.111-.03.161-.051.161-.051a1.067,1.067,0,0,0-.172.02c-.131.02-.293.05-.495.081-.464.091-1.09.212-1.887.363q-.621.121-1.362.272c-.5.081-1.05.141-1.635.222-1.171.141-2.5.373-4,.424-.747.05-1.524.091-2.331.141s-1.655,0-2.533.01c-1.756.04-3.613-.131-5.581-.262a64.354,64.354,0,0,1-24.362-7.317c-1.716-.969-3.361-1.857-4.8-2.856-.727-.484-1.453-.918-2.109-1.4s-1.272-.959-1.867-1.4a39.62,39.62,0,0,1-3.1-2.553c-.444-.393-.878-.737-1.241-1.08s-.686-.676-.989-.969c-.585-.565-1.039-1.009-1.372-1.342-.151-.141-.262-.252-.363-.343a.786.786,0,0,0-.131-.111Z",
    transform: "translate(-312.277 -734.779)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9425",
    "data-name": "Path 9425",
    d: "M490.28,817.5s.03.06.1.172c.091.121.192.283.333.474.313.434.757,1.029,1.312,1.8,1.14,1.554,2.8,3.795,4.925,6.519a94.6,94.6,0,0,0,8,9.1,45.753,45.753,0,0,0,5.5,4.6,29.537,29.537,0,0,0,6.812,3.583,28.575,28.575,0,0,0,14.714.9,49.866,49.866,0,0,0,6.247-1.736c1.907-.7,3.663-1.393,5.248-2.089,3.159-1.373,5.682-2.584,7.418-3.411.848-.4,1.524-.727,2-.959.212-.1.383-.192.515-.262a.829.829,0,0,0,.172-.1s-.061.02-.182.071c-.141.061-.313.131-.535.222-.484.212-1.171.515-2.029.9-1.756.787-4.289,1.958-7.458,3.3-1.584.676-3.341,1.362-5.248,2.039a49.961,49.961,0,0,1-6.217,1.7,28.455,28.455,0,0,1-14.543-.908,29.416,29.416,0,0,1-6.731-3.532,45.73,45.73,0,0,1-5.47-4.552,99.868,99.868,0,0,1-8.033-9.022c-2.15-2.695-3.825-4.915-5.006-6.439-.575-.747-1.039-1.332-1.362-1.756q-.227-.272-.363-.454c-.081-.1-.131-.151-.131-.141Z",
    transform: "translate(-312.324 -734.888)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5367",
    "data-name": "Group 5367",
    transform: "translate(158.63 230.102)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9426",
    "data-name": "Path 9426",
    d: "M510.331,976.517c-2.452-3.25-6.974-3.855-11.041-4.087s-8.286.02-12.03-1.584c-2.816-1.211-5.117-3.381-7.832-4.794s-6.358-1.907-8.639.141a64.587,64.587,0,0,0,39.541,10.324",
    transform: "translate(-470.79 -964.82)",
    fill: "#cae4fe"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivationLinkExpired);
export default __webpack_public_path__ + "static/media/ic_activation_link_expired.0c08f866a300ac92623d4de68f4d8af1.svg";
export { ForwardRef as ReactComponent };